import { ActionCreatorWithPayload } from '@reduxjs/toolkit/dist/createAction';

type FetchOptions = {
    reduxAction?: ActionCreatorWithPayload<unknown>;
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
    body?: unknown;
    headers?: HeadersInit;
    mode?: RequestMode;
    baseURL?: string;
};

type API_RESPONSE<T> = {
    statusCode: number;
    ok: boolean;
    data: T | null;
    headers: Headers;
};

type API_RESPONSE_DATA_DEFAULT = {
    message: string;
    status: string;
};

const fetchHelper = async <Tres = API_RESPONSE_DATA_DEFAULT>(
    url: string,
    options?: FetchOptions
): Promise<API_RESPONSE<Tres>> => {
    const response = await fetch(`${options?.baseURL || import.meta.env.VITE_API_SERVICE}/${url}`, {
        ...options,
        body: options?.body ? JSON.stringify(options.body) : undefined,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers,
        },
    });

    if (!response.ok) {
        let errorMessage = `Error ${response.status}: ${response.statusText}`;
        try {
            const errorData = await response.json();
            if (errorData?.message) {
                errorMessage = errorData?.message;
            }
        } catch {}
        throw new Error(errorMessage);
    }

    if (response.status === 204 || response.headers.get('Content-Length') === '0') {
        return { statusCode: response.status, ok: response.ok, headers: response.headers, data: null };
    }

    const isJson = response.headers.get('Content-Type')?.includes('application/json');

    const data = isJson ? await response.json() : await response.blob();

    return { statusCode: response.status, ok: response.ok, headers: response.headers, data };
};

export default fetchHelper;
